import { useMediaQuery } from '@mui/material';
import { isMobileQuery } from '../utils/makeStyles';

export const useScreenSize = () => {
  const isMobile = useMediaQuery(`(max-width:${isMobileQuery})`);

  return { isMobile };
};
